"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _validate = _interopRequireDefault(require("validate.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const validator = _validate.default;
const hasLowerCase = (value, options) => {
  if (/[a-z]/.test(value)) {
    return;
  }
  return options.message || "must contain a lowercase character";
};
const hasUpperCase = (value, options) => {
  if (/[A-Z]/.test(value)) {
    return;
  }
  return options.message || "must contain an uppercase character";
};
const hasNumber = (value, options) => {
  if (/[0-9]/.test(value)) {
    return;
  }
  return options.message || "must contain a number";
};
const hasAWSPasswordSplChar = (value, options) => {
  // eslint-disable-next-line no-useless-escape
  if (/[\^\$\*\.\[\]\{\}\(\)\?\-\"\!\@\#\%\&\/\,\>\<\'\:\;\|\_\~\`]/.test(value)) {
    return;
  }
  return options.message || "must contain a special character";
};
const array = (arrayItems, itemConstraints, key) => {
  if (!_validate.default.isArray(arrayItems)) {
    return `${key} is not a valid array`;
  }
  const arrayItemErrors = arrayItems.reduce((errors, item) => {
    const error = (0, _validate.default)(item, itemConstraints, {
      format: "grouped"
    });
    if (!!error) errors.push(error);
    return errors;
  }, []);
  return _validate.default.isEmpty(arrayItemErrors) ? null : `^${JSON.stringify(arrayItemErrors)}`;
};
const validURL = (str, options) => {
  const httpPattern = new RegExp(/* eslint-disable-next-line */
  /https?:\/\/(www\.)?[-a-zA-ZА-Яа-я0-9@:%._\+~#=]{1,256}\.[a-zA-ZА-Яа-я0-9]{1,6}\b([-a-zA-ZА-Яа-я0-9!@:%_\+.~#?&\/\/=]*)$/gm);
  const worldWebPattern = new RegExp(/* eslint-disable-next-line */
  /(www\.)[-a-zA-ZА-Яа-я0-9@:%._\+~#=]{1,256}\.[a-zA-ZА-Яа-я0-9]{1,6}\b([-a-zA-ZА-Яа-я0-9!@:%_\+.~#?&\/\/=]*)$/gm);
  if (httpPattern.test(str) || worldWebPattern.test(str)) {
    return;
  }
  return options.message || `${str} is not a valid URL.`;
};
const validHTTPS = (str, options) => {
  const httpsPattern = new RegExp(/* eslint-disable-next-line */
  /https:\/\/(www\.)?[-a-zA-ZА-Яа-я0-9@:%._\+~#=]{1,256}\.[a-zA-ZА-Яа-я0-9]{1,6}\b([-a-zA-ZА-Яа-я0-9!@:%_\+.~#?&\/\/=]*)$/gm);
  const testPattern = httpsPattern.test(str);
  if (testPattern) {
    return;
  }
  return options.message || `${str} hasn't sertificate.`;
};
const validDaemonEndpoint = (str, options) => {
  const httpPattern = new RegExp(/* eslint-disable-next-line */
  /https?:\/\/(www\.)?[-a-zA-ZА-Яа-я0-9@:%._\+~#=]{1,256}\.[a-zA-ZА-Яа-я0-9]{1,6}\b([-a-zA-ZА-Яа-я0-9!@:%_\+.~#?&\/\/=]*)$/gm);
  if (httpPattern.test(str)) {
    return;
  }
  return options.message || `${str} is not a valid URL.`;
};
const validEmail = (value, options) => {
  const regexEmail = new RegExp(/* eslint-disable-next-line */
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
  if (regexEmail.test(value)) {
    return;
  }
  return options.message || `${value}  is not valid email`;
};
const validPhone = (value, options) => {
  /* eslint-disable-next-line */
  const regexPhone = new RegExp(/^[\+]?[0-9]{10,15}$/gm);
  if (regexPhone.test(value)) {
    return;
  }
  return options.message || `${value} is not a valid phone number. Phone number should include plus sign, country code and area code.`;
};
const validDUNS = (value, options) => {
  /* eslint-disable-next-line */
  const regexDUNS = new RegExp(/^[0-9]{9}$/gm);
  if (regexDUNS.test(value)) {
    return;
  }
  return options.message || `${value} is not a valid DUNS number. DUNS number should include nine digits.`;
};
const validName = (value, options) => {
  /* eslint-disable-next-line */
  const regexOrganizationName = new RegExp(/^[-.a-zA-Z0-9_ ]*$/);
  if (regexOrganizationName.test(value)) {
    return;
  }
  return options.message || `${value} is not a valid.`;
};
const validLighthouseToken = (value, options) => {
  /* eslint-disable-next-line */
  const regexLighthouseToken = new RegExp(/^(?:[0-9a-z\d]{8})+\.+(?:[0-9a-z\d]{32})$/);
  if (regexLighthouseToken.test(value)) {
    return;
  }
  return options.message || `Is not a valid.`;
};
validator.validators = {
  ..._validate.default.validators,
  // custom validators
  validDaemonEndpoint,
  hasLowerCase,
  hasUpperCase,
  hasNumber,
  hasAWSPasswordSplChar,
  array,
  validURL,
  validHTTPS,
  validEmail,
  validPhone,
  validName,
  validDUNS,
  validLighthouseToken
};
validator.options = {
  format: "flat"
};
var _default = exports.default = validator;